export default __webpack_public_path__ + "static/media/ic_galapagos_islands.5b7d3c4f.svg";